import { Image } from 'react-native';

// eslint-disable-next-line import/prefer-default-export
export const Images = {
  ic_business_team: Image.resolveAssetSource(require('../../../assets/Icons/icBusinessTeam.png')),
  ic_admin: Image.resolveAssetSource(require('../../../assets/Icons/icAdminRed.png')),
  ic_members: Image.resolveAssetSource(require('../../../assets/Icons/ic_members.png')),
  ic_Delete_Red: Image.resolveAssetSource(require('../../../assets/Icons/delete.png')),
  ic_category: Image.resolveAssetSource(require('../../../assets/Icons/ic_categories.png')),
  ic_search: Image.resolveAssetSource(require('../../../assets/Icons/icSearch.png')),
  ic_business: Image.resolveAssetSource(require('../../../assets/Icons/icBusiness.png')),
  ic_add_white: Image.resolveAssetSource(require('../../../assets/Icons/icAddWhite.png')),
  ic_calender_red: Image.resolveAssetSource(require('../../../assets/Icons/icCalendarRed.png')),
  ic_folder_red: Image.resolveAssetSource(require('../../../assets/Icons/icFolderRed.png')),
  ic_text_area: Image.resolveAssetSource(
    require('../../../assets/Icons/iconsIndicatorsSystemIconsComment333333.png'),
  ),
  ic_licences: Image.resolveAssetSource(require('../../../assets/Icons/tablet-mobile.png')),
  marketplace_header: Image.resolveAssetSource(require('../../../assets/Images/image-header.png')),
  ic_inactive_heart: Image.resolveAssetSource(require('../../../assets/Icons/inactiveHeart.png')),
  ic_active_heart: Image.resolveAssetSource(require('../../../assets/Icons/activeHeart.png')),
  devices_empty: Image.resolveAssetSource(require('../../../assets/Images/mobile_red.png')),
  licences_empty: Image.resolveAssetSource(require('../../../assets/Images/folder.png')),
  icInfoCircle: Image.resolveAssetSource(require('../../../assets/Icons/info-circle-black.png')),
  icInfoCircleTransparent: Image.resolveAssetSource(
    require('../../../assets/Icons/icInfoCircleTransparent.png'),
  ),
  ic_plan: Image.resolveAssetSource(require('../../../assets/Icons/plan.png')),
  icBundlesRed: Image.resolveAssetSource(require('../../../assets/Icons/icBundlesRed.png')),
  icPlus: Image.resolveAssetSource(require('../../../assets/Icons/add.png')),
  icMinus: Image.resolveAssetSource(require('../../../assets/Icons/minus.png')),
  ic_enterprise: Image.resolveAssetSource(require('../../../assets/Icons/icEnterprise.png')),
  ic_business_team_red: Image.resolveAssetSource(
    require('../../../assets/Icons/icBusinessTeamRed.png'),
  ),
  info_circle: Image.resolveAssetSource(require('../../../assets/Icons/info-circle.png')),
  ic_business_team_users: Image.resolveAssetSource(require('../../../assets/Icons/users.png')),
  ic_users_new: Image.resolveAssetSource(require('../../../assets/Icons/users_red.png')),
};
